import { MilestoneItemType } from '@insurancemenu/imenu-components-lib/dist/types';
import { SubChecklistCard } from 'types/electionService';
import { calculateMilestoneStatus } from 'global/utils/calculateMilestoneStatus';
import { ChecklistOption } from 'types/enrollmentService';
import { ROUTES_CONFIG_V2 } from 'routes/routesConfigV2';
import { isSubscriberV2ChecklistCard, SUBSCRIBER_V2_CHECKLIST_MAPPING } from 'store/flows/subscriber/checklistMapping';

export interface SubscriberRedirectParams {
  // PeriodId/TaskId
  entityId: string;
  subId: string;
  groupId?: string;
}

export interface EmployeeProfileRedirectParams {
  groupId: string;
}

export interface SubCardTextObject {
  title: string;
  text: string;
  redirectTo: (params: SubscriberRedirectParams) => string;
  tutorialLink: string;
}

type LegacySubChecklistCard = Exclude<
  SubChecklistCard,
  | SubChecklistCard.HEALTH_QUESTIONNAIRE
  | SubChecklistCard.IMQ_GENERAL_INFO
  | SubChecklistCard.IMQ_SUBSCRIBER_PROFILE
  | SubChecklistCard.IMQ_SUBSCRIBER_DEPENDENTS
>;

export type { LegacySubChecklistCard };

type CardDataObjectType = {
  [K in LegacySubChecklistCard]: SubCardTextObject;
};

/**
 * @deprecated We slowly migrate the existing & new pages to the new breadcrumb structure and move them to the subscriber/checklistMapping .
 */
export const SUBSCRIBER_CARD_DATA: CardDataObjectType = Object.freeze({
  MANAGE_SUBSCRIBER: {
    title: 'Manage Benefits',
    text: ' Make elections, update your employee profile,and add/remove dependents on your policies',
    redirectTo: ({ entityId, subId, groupId }: SubscriberRedirectParams): string => {
      return `/manage-subscriber/${entityId}?subId=${subId}&groupId=${groupId}`;
    },
    tutorialLink: '#',
  },
  REVIEW_AND_CONFIRM: {
    title: 'Review & Confirm',
    text: 'Final review of all elections and profile details before submitting',
    redirectTo: ({ entityId, subId, groupId }: SubscriberRedirectParams): string => {
      return `/review-subscriber/${entityId}?subId=${subId}&groupId=${groupId}`;
    },
    tutorialLink: '#',
  },
  SUBSCRIBER_PROFILE: {
    title: 'Employee Profile',
    text: 'Fill out the required fields to complete the profile',
    redirectTo: ({ entityId, subId, groupId }: SubscriberRedirectParams): string => {
      return `/subscriber-profile/${groupId}?subId=${subId}&entityId=${entityId}`;
    },
    tutorialLink: '#',
  },
  SUBSCRIBER_DEPENDENTS: {
    title: 'Manage Dependents',
    text: 'Manage dependents associated with your profile',
    redirectTo: ({ entityId, subId, groupId }: SubscriberRedirectParams): string => {
      return `/subscriber-manage-dependents/${groupId}?subId=${subId}&entityId=${entityId}`;
    },
    tutorialLink: '#',
  },
  SUBSCRIBER_DOCUMENTS_IMQ: {
    title: 'Subscriber IMQ Documents',
    text: 'Upload required documents for your profile',
    redirectTo: ({ entityId, subId, groupId }: SubscriberRedirectParams): string => {
      return `/subscriber-imq-documents/${groupId}?subId=${subId}&entityId=${entityId}`;
    },
    tutorialLink: '#',
  },
  QUOTING_SUBSCRIBER_PROFILE: {
    title: 'Employee Profile',
    text: 'Fill out the required fields to complete the profile',
    redirectTo: ({ entityId, subId, groupId }: SubscriberRedirectParams): string => {
      return `/quote-subscriber-profile/${groupId}?subId=${subId}&entityId=${entityId}`;
    },
    tutorialLink: '#',
  },
  QUOTING_ELECTIONS: {
    title: 'Interested Product Lines',
    text: 'Choose your product lines of interest',
    redirectTo: ({ entityId, subId, groupId }: SubscriberRedirectParams): string => {
      return `/quote-manage-elections/${groupId}?subId=${subId}&entityId=${entityId}`;
    },
    tutorialLink: '#',
  },
});

/**
 * @deprecated Use the SubscriberRouteV2Id.EMPLOYEE_PROFILE route instead.
 */
export const getEmployeeProfileURL = ({ groupId }: EmployeeProfileRedirectParams): string => {
  return `/employee?groupId=${groupId}`;
};

export const getMilestones = (checklistOptions: ChecklistOption<SubChecklistCard>[]): MilestoneItemType[] => {
  return checklistOptions.map((option) => {
    const label = isSubscriberV2ChecklistCard(option.card)
      ? ROUTES_CONFIG_V2[SUBSCRIBER_V2_CHECKLIST_MAPPING[option.card]].title
      : SUBSCRIBER_CARD_DATA[option.card].title;

    return {
      label,
      status: calculateMilestoneStatus(option.buttonState),
    };
  });
};
